export const agents = {
  seo: {
    title: 'Become a Bistroo Sales Agent: 40% Recurring Commission',
    description: 'Sell next-gen restaurant software in NL, BE & DE. Earn 40% recurring commission with a €1,500/month ramp-up guarantee.',
  },
  hero: {
    badge: 'Now recruiting agents in NL, BE & DE',
    title_1: 'Sell restaurant tech that sells itself. Earn',
    title_em: '40% recurring commission',
    title_2: 'for as long as your clients stay.',
    subtitle: 'Bistroo is the next-gen e-commerce suite for quick-service restaurants: webshops, websites, QR ordering, kiosks, and POS. You bring the restaurants. We make sure they never leave. And you get paid, every month they stay.',
    cta_primary: 'Become an agent',
    cta_secondary: 'See the deal ↓',
    stats: [
      { value: '40%', label: 'recurring commission' },
      { value: '€1,500/mo', label: 'launch guarantee, 4 months' },
      { value: 'Weekly', label: 'paid out during launch' },
      { value: '3', label: 'countries to sell in' },
    ],
  },
  products: {
    kicker: "What you'll be selling",
    heading: 'Software restaurant owners actually love.',
    lead: 'Bistroo serves quick-service restaurants with a complete, plug-and-play ordering suite: no long-term contracts, monthly cancellation, entry pricing with a premium feel. That makes for an easy yes at the counter.',
    items: [
      { icon: '🛍️', title: 'Webshop & Website', text: 'Fully customizable takeout & delivery webshops plus a restaurant-owned website. Own channel, own customers, own data.' },
      { icon: '📱', title: 'QR Table Ordering', text: 'Guests scan, order and pay from their table. Less running, more revenue per service.' },
      { icon: '🖥️', title: 'Kiosk & POS', text: 'Self-service kiosks and a POS module built for quick-service. One suite, one subscription, managed in the intuitive Bistroo Manager.' },
    ],
  },
  deal: {
    kicker: 'The deal',
    heading: 'Build income that compounds. Not a one-time bonus.',
    lead: 'Most sales deals pay once. We pay you 40% of the recurring revenue from every restaurant you onboard, every month they stay with Bistroo. Onboard once, earn forever.',
    commission: {
      title: 'Recurring commission',
      value: '40%',
      text: "On the recurring revenue from every business customer you onboard, for as long as they remain an active Bistroo partner. Your portfolio grows and your monthly income grows with it.",
    },
    retainer: {
      pill: 'Ramp-up guarantee',
      title: 'Your first 4 months, risk-free.',
      value: '€1,500/mo',
      text: 'Recurring commission takes time to build, so we bridge that. Onboard 8 new business customers in a month and we guarantee you €1,500 that month, paid weekly: convert 2 business customers in a week, and you get paid that week.',
    },
  },
  ramp: {
    kicker: 'How the ramp works',
    heading: 'From guaranteed retainer to self-sustaining commission in 4 months.',
    lead: "Keep the pace of 8 onboarded business customers per month and the math does the rest: after month 4 you're holding a portfolio of 32+ restaurants generating at least €1,440 in monthly commission, and it keeps growing with every customer you add.",
    table_headers: ['Month', 'Target (new clients)', 'Portfolio total', 'Guaranteed payout'],
    table_rows: [
      ['1', '8', '8', '€1,500 (weekly installments)'],
      ['2', '8', '16', '€1,500 (weekly installments)'],
      ['3', '8', '24', '€1,500 (weekly installments)'],
      ['4', '8', '32', '€1,500 (weekly installments)'],
      ['Month 5+', 'Your pace', '32+', '€1,440+ /month at 40% recurring'],
    ],
    note: 'Ramp-up retainer terms: maximum duration 4 months. The monthly guarantee applies when you onboard 8 new business customers in that month; the weekly payout applies in weeks where you convert 2 business customers. The €1,440+ figure is the minimum expected monthly commission at a portfolio of 32 clients. Actual earnings depend on the modules your clients use and grow as your portfolio grows. General terms apply; the full agent agreement is shared during onboarding.',
    checks: [
      { strong: 'No cap on your earnings.', text: '32 clients is the floor, not the ceiling. Keep onboarding and your recurring income keeps stacking.' },
      { strong: 'You sell, we deliver.', text: 'Our team handles setup, design and support. Your clients are in good hands and your portfolio stays healthy.' },
      { strong: 'A fair product to stand behind.', text: "Monthly subscriptions, no lock-in. Restaurants stay because they want to. That's exactly why recurring commission works." },
    ],
  },
  steps: {
    kicker: 'Getting started',
    heading: 'From sign-up to first payout in four steps.',
    items: [
      { title: 'Apply', text: 'Fill out the sign-up form (2 minutes). Tell us about your network and region.' },
      { title: 'Intro & onboarding', text: 'A personal call, product training and your agent toolkit: demo environment, pricing, and materials.' },
      { title: 'Start selling', text: 'Hit the streets, work your network. We support every deal with fast setup so your clients go live quickly.' },
      { title: 'Get paid weekly', text: 'Convert 2 business customers in a week and your ramp-up payment lands that same week.' },
    ],
  },
  who: {
    kicker: "Who we're looking for",
    heading: 'Hunters with hospitality in their blood.',
    items: [
      { icon: '🤝', title: 'Connected', text: 'You know restaurant owners, or you know how to get in front of them. A network in quick-service, takeout or delivery is a head start.' },
      { icon: '⚡', title: 'Self-driven', text: 'You set your own pace and run your own pipeline. We give you the tools, training and back-up. You bring the drive.' },
      { icon: '🌍', title: 'Based in NL, BE or DE', text: "We're live in the Netherlands and Belgium, and launching in Germany in 2026. Early agents get first pick of their territory." },
    ],
  },
  cta: {
    heading: 'Ready to build your portfolio?',
    text: "Apply in 2 minutes. We'll reach out within two business days to schedule your intro call.",
    button: 'Apply via the form',
    small: 'Terms & conditions apply. The full agent agreement and commission terms are formalised during onboarding.',
  },
}
